import { CROP_TYPE } from "../crop.types";

export default (preferredCropAlias?: CROP_TYPE, cropFallback?: CROP_TYPE): number => {
    const findHeightRatio = (crop?: CROP_TYPE): number | undefined => {
        if (crop === "Square (1:1)") {
            return 1;
        }
        else if (crop === "Fullscreen (4:3)") {
            return 0.75;
        }
        else if (crop === "Widescreen (16:9)") {
            return 0.5625;
        }
        else if (crop === "Ultrawide (21:9)") {
            return 0.4285;
        }
        else {
            return undefined;
        }
    };

    const heightRatio = findHeightRatio(preferredCropAlias);

    if (typeof(heightRatio) !== "undefined") {
        return heightRatio;
    }
    else {
        return findHeightRatio(cropFallback) || 0.5625; // Fallback Widescreen (16:9)
    }
};
